import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  { q: "Is DOX just a chatbot?", a: "No. DOX is an AI Compliance Employee. It performs administrative and compliance work — reviewing, organizing, monitoring deadlines and preparing paperwork — rather than just answering questions." },
  { q: "Does DOX give legal advice?", a: "No. DOX never invents government requirements, filing fees, deadlines or legal advice. It surfaces information from your documents and, where possible, verifies recommendations against official sources — always with a confidence level and source attribution." },
  { q: "What documents can I upload?", a: "Licenses, permits, insurance certificates, surety bonds, tax forms, contracts and more. DOX categorizes each one automatically and remembers your business profile over time." },
  { q: "How secure are my documents?", a: "Your documents are encrypted and stored privately. Only you can access your files through your authenticated account." },
  { q: "What does it cost?", a: "$99/month for full access, including a 14-day free trial with no credit card required." },
  { q: "Which trades is EZDoxAI built for?", a: "General contractors, electricians, plumbers, HVAC, roofing and other licensed trades that deal with state compliance and trade documentation." },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="text-center mb-14">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-dox-orange mb-4">FAQ</div>
          <h2 className="font-display font-black tracking-tight text-4xl sm:text-5xl">
            Questions, <span className="text-gradient-brand">answered.</span>
          </h2>
        </div>

        <Reveal>
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-xl border border-white/10 bg-surface px-5 data-[state=open]:border-dox-orange/40 transition-colors"
              >
                <AccordionTrigger className="text-left font-display font-semibold text-white hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/60 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
